import { getLocale, getProfileId } from 'lib/store';
import { apiClient } from 'services/api-client';
import {
  LabReportResponse,
  LabReportDetail,
  PostQuestionnairePayload,
} from './type';
import { ReportQuestion } from '../../types';

export const getLabReports = async (args?: {
  page_number: number;
  page_size: number;
}) => {
  return (await apiClient.get('/lab_report_details', {
    params: {
      locale: getLocale(),
      profile_id: getProfileId(),
      os: 'web',
      page_number: args?.page_number || 1,
      page_size: args?.page_size || 10,
    },
  })) as LabReportResponse;
};

export const getLabReportDetail = async (token_id: string) => {
  return (await apiClient.get('/lab_report_details', {
    params: {
      locale: getLocale(),
      profile_id: getProfileId(),
      token_id,
      os: 'web',
    },
  })) as LabReportDetail[];
};

export const getLabReportQuestionnaire = async (
  type: string,
  q_id?: string
) => {
  return (await apiClient.get('/lab_report', {
    params: {
      locale: getLocale(),
      profile_id: getProfileId(),
      os: 'web',
      type,
      ...(q_id && { q_id }),
    },
  })) as ReportQuestion[];
};

export const postLabReportQuestionnaire = async (
  payload: PostQuestionnairePayload
) => {
  const { answer_id, ...restPayload } = payload;

  const data = payload?.answer_id ? payload : restPayload;

  return (await apiClient.post(
    `/lab_report?os=web&locale=${getLocale()}&profile_id=${getProfileId()}`,
    data
  )) as ReportQuestion;
};

export const labReportFileUpload = async (data: any) => {
  return (await apiClient.post(
    `/lab_report_file_upload?os=web&locale=${getLocale()}&profile_id=${getProfileId()}`,
    data
  )) as { token_id: string };
};

export const deleteLabReport = async (token_id: string[]) => {
  return await apiClient.delete(
    `/lab_report_details?pos=web&locale=${getLocale()}&profile_id=${getProfileId()}`,
    { data: { token_id } }
  );
};
